import { TenantViewModel } from '@ail/customers-api'
import { FuelCardViewModel, TenantFuelCardSetInputModel, TenantFuelCardSetViewModel } from '@ail/orders-api'
import React, { Component } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { ConnectedProps, connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { ObjectHelper } from '../../../../helpers/ObjectHelper'
import { wrapQuery } from '../../../../redux/api/apiQuery'
import { customersApi } from '../../../../redux/api/customerApi'
import { ordersApi } from '../../../../redux/api/ordersApi'
import { emptyGuid, newItemId } from '../../../../types/constants'
import FuelCard from '../../../common/FuelCard/FuelCard'
import { Loader } from '../../../common/Loader/Loader'

type IEditGroupFuelCardSetProps = ConnectedProps<typeof connector> &
  WithTranslation &
  RouteComponentProps<{ id: string }>

interface IEditGroupFuelCardSetState {
  fuelCards: FuelCardViewModel[]
  tenantFuelCardSets: TenantFuelCardSetViewModel[]
  tenants: TenantViewModel[]
  loading: boolean
  fuelCardsList: FuelCardViewModel[]
  set: TenantFuelCardSetInputModel & { id?: string }
}

class EditGroupFuelCardSet extends Component<IEditGroupFuelCardSetProps, IEditGroupFuelCardSetState> {
  constructor(props: IEditGroupFuelCardSetProps) {
    super(props)

    this.state = {
      fuelCards: [],
      tenantFuelCardSets: [],
      tenants: [],
      loading: false,
      fuelCardsList: [],
      set: {
        tenantId: emptyGuid,
        maxFuelCards: 0,
        fuelCards: [],
      },
    }
  }

  public componentDidMount(): void {
    this.setState({
      loading: true,
    })

    const id = this.props.match?.params?.id

    const p1 = this.props.loadTenants()
    const p2 = this.props.getFuelCards()
    const p3 = id && id !== newItemId ? this.props.getTenantFuelCardSet(id) : Promise.resolve(undefined)

    Promise.all([p1, p2, p3]).then(
      ([tenants, fuelCards, tenantFuelCardSet]) => {
        this.setState({
          set: !tenantFuelCardSet ? { id: '', tenantId: emptyGuid, maxFuelCards: 0, fuelCards: [] } : this.state.set,
          loading: false,
          tenants,
          fuelCards,
          tenantFuelCardSets: tenantFuelCardSet ? [tenantFuelCardSet] : this.state.tenantFuelCardSets,
        })
      },
      () => this.setState({ loading: false })
    )
  }

  public componentDidUpdate(
    prevProps: Readonly<IEditGroupFuelCardSetProps>,
    prevState: Readonly<IEditGroupFuelCardSetState>
  ): void {
    if (this.state.fuelCards !== prevState.fuelCards && this.state.fuelCards.length) {
      const fuelCardsTest = ObjectHelper.clone(this.state.fuelCards)
      const noneFuelCard = fuelCardsTest.splice(
        this.state.fuelCards.findIndex((el) => el.key === 'none'),
        1
      )
      fuelCardsTest.push(noneFuelCard[0])
      this.setState({ fuelCardsList: fuelCardsTest })
    }
    if (this.state.tenantFuelCardSets !== prevState.tenantFuelCardSets) {
      const id = this.getTenantFuelCardSetId()
      if (id !== newItemId) {
        const set = this.state.tenantFuelCardSets.find((tfcs) => tfcs.id === id)
        if (set) {
          this.setState({
            set: {
              ...set,
              fuelCards: set.fuelCards?.map((fc) => fc.id!) ?? [],
            },
          })
        } else {
          this.setState({
            set: {
              tenantId: emptyGuid,
              maxFuelCards: 0,
              fuelCards: [],
            },
          })
          alert('Group fuel card set loading failed!')
        }
      }
    }
  }

  public render() {
    const { tenants } = this.state
    const { loading, set } = this.state
    return (
      <Loader blocking={loading} style={{ overflow: 'hidden' }} className="editFuel">
        <div className="ordersArea newFormArea">
          <div className="ordersFormArea">
            <div className="detailTitle">
              <i className="icon-fuelcard"></i>
              <span>New/edit Fuel Card Set</span>
            </div>
            {!!set && (
              <>
                <div className="ordersForm">
                  <div className="formGroup hidden">
                    <label>Key </label>
                    <input disabled={true} type="text" name="id" value={set?.id} />
                  </div>
                  <div className="formGroup">
                    <label>Group </label>
                    <div className="selectArea">
                      <select
                        onChange={(e) => {
                          this.tenantSelectUpdated(e)
                        }}
                      >
                        <option disabled={true} selected={set.tenantId === emptyGuid} value={emptyGuid}>
                          Please select a group
                        </option>
                        {tenants.map((t) => (
                          <option selected={set.tenantId === t.id} value={t.id}>
                            {t.name}
                          </option>
                        ))}
                      </select>
                      <i className="icon-bottom" />
                    </div>
                  </div>
                  <div className="formGroup">
                    <label>Max fuel cards </label>
                    <input
                      type="number"
                      name="maxFuelCards"
                      step={1}
                      min={0}
                      value={set?.maxFuelCards}
                      onChange={(e) => this.setState({ set: { ...this.state.set, maxFuelCards: +e.target.value } })}
                    />
                  </div>
                  <label>Fuel cards</label>
                  <div className="formGroup">
                    <ul className="fuelList">
                      {this.state.fuelCardsList.map((fc) => (
                        <li>
                          <FuelCard
                            onInputChange={(e) => this.fcUpdated(e)}
                            managementFuelCard={fc}
                            input={true}
                            set={set}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="btnArea">
                  <button className="btn btnClose" onClick={() => this.cancel()}>
                    <i className="icon-close"></i> Cancel
                  </button>
                  <button className="btn btnSave" onClick={() => this.save()}>
                    <i className="icon-save"></i> Save
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </Loader>
    )
  }

  private tenantSelectUpdated(e: React.ChangeEvent<HTMLSelectElement>) {
    const set = { ...this.state.set, tenantId: e.target.value }
    this.setState({
      set,
    })
  }

  private fcUpdated(e: React.ChangeEvent<HTMLInputElement>): void {
    const value = e.target.value
    const set = { ...this.state.set, fuelCards: [...(this.state.set.fuelCards ?? [])] }

    if (set.fuelCards.includes(value)) {
      set.fuelCards = set.fuelCards.filter((fc) => fc !== value)
    } else {
      set.fuelCards.push(value)
    }

    this.setState({
      set,
    })
  }

  private getTenantFuelCardSetId(): string {
    return this.props.match?.params?.id
  }

  private save() {
    if (this.state.set.tenantId === emptyGuid) {
      alert('Please select a group!')
      return
    }
    this.setState({
      loading: true,
    })
    const id = this.props.match.params.id
    if (id === newItemId) {
      this.props
        .postTenantFuelCardSet(this.state.set)
        .then(() => {
          this.setState({ loading: false })
          this.props.history.push('/RequestsManagement/GroupFuelCardSets')
        })
        .catch(() => {
          alert('Fuel card saving failed!')
          this.setState({ loading: false })
        })
    } else {
      this.props
        .putTenantFuelCardSet(id, this.state.set)
        .then(() => {
          this.setState({ loading: false })
          this.props.history.push('/RequestsManagement/GroupFuelCardSets')
        })
        .catch(() => {
          alert('Fuel card saving failed!')
          this.setState({ loading: false })
        })
    }
  }

  private cancel() {
    this.props.history.push('/RequestsManagement/GroupFuelCardSets')
  }
}

/**
 * decide what part of state should be exposed
 * @param state  redux state
 * @param ownProps props of component
 */
function mapStateToProps() {
  return {}
}

/**
 * What action should be passed to component
 */
const mapDispatchToProps = {
  getFuelCards: wrapQuery(() => ordersApi.endpoints.getFuelCards.initiate()),
  getTenantFuelCardSet: wrapQuery((id: string) => ordersApi.endpoints.getTenantFuelCardSet.initiate(id)),
  postTenantFuelCardSet: wrapQuery((model: TenantFuelCardSetInputModel, final?: boolean) =>
    ordersApi.endpoints.postTenantFuelCardSet.initiate({ model, final })
  ),
  putTenantFuelCardSet: wrapQuery((id: string, model: TenantFuelCardSetInputModel, final?: boolean) =>
    ordersApi.endpoints.putTenantFuelCardSet.initiate({ id, model, final })
  ),
  loadTenants: wrapQuery(() => customersApi.endpoints.getTenants.initiate()),
}

const connector = connect(mapStateToProps, mapDispatchToProps)
// eslint-disable-next-line react-refresh/only-export-components
export default connector(withTranslation('common')(EditGroupFuelCardSet))
